/* PACKRUSH v3 — rip hero, release calendar, rewards slider, product page tabs. No dependencies. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ready = function (fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); };
  var onAll = function (fn) { ready(fn); document.addEventListener('shopify:section:load', fn); };

  /* ---------------- Rip hero ---------------- */
  function initRip() {
    document.querySelectorAll('[data-rip]').forEach(function (hero) {
      if (hero.dataset.ripBound) return; hero.dataset.ripBound = '1';
      var pack = hero.querySelector('[data-rip-pack]');
      var again = hero.querySelector('[data-rip-again]');
      var cards = [].slice.call(hero.querySelectorAll('.rxrip-card'));
      var packs = again ? parseInt(again.dataset.packs, 10) || 1 : 1;
      var batch = 0, busy = false, timer = 0;

      function showBatch(b) {
        cards.forEach(function (c) { c.hidden = String(b) !== c.dataset.batch; c.classList.remove('is-front'); });
      }
      function rip() {
        if (busy || hero.dataset.state === 'open') return;
        busy = true;
        if (reduce) { hero.dataset.state = 'open'; busy = false; if (again) again.disabled = false; return; }
        hero.dataset.state = 'ripping';
        setTimeout(function () {
          hero.classList.remove('is-burst'); void hero.offsetWidth; hero.classList.add('is-burst');
          hero.dataset.state = 'open';
          setTimeout(function () { busy = false; if (again) again.disabled = false; }, 800);
        }, 420);
      }
      function close(next) {
        if (busy) return;
        busy = true; if (again) again.disabled = true;
        hero.dataset.state = 'sealed';
        setTimeout(function () {
          batch = (batch + 1) % packs; showBatch(batch);
          busy = false;
          if (next) setTimeout(rip, reduce ? 0 : 450);
        }, reduce ? 0 : 650);
      }
      pack.addEventListener('click', rip);
      if (again) again.addEventListener('click', function () { close(true); });

      showBatch(0);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          if (en[0].isIntersecting) { io.disconnect(); clearTimeout(timer); timer = setTimeout(rip, reduce ? 0 : 900); }
        }, { threshold: .35 });
        io.observe(hero);
      } else { rip(); }
    });
  }
  onAll(initRip);

  /* ---------------- Release calendar ---------------- */
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function iso(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function parse(s) { var p = s.split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); }

  function initCal() {
    document.querySelectorAll('[data-cal]').forEach(function (root) {
      if (root.dataset.calBound) return; root.dataset.calBound = '1';
      root.classList.add('is-js');
      var rows = [].slice.call(root.querySelectorAll('.rxcal__row'));
      if (!rows.length) { root.hidden = true; return; }
      var byDate = {};
      rows.forEach(function (r) { (byDate[r.dataset.date] = byDate[r.dataset.date] || []).push(r); });
      var dates = Object.keys(byDate).sort();
      var months = [];
      dates.forEach(function (d) { var m = d.slice(0, 7); if (months.indexOf(m) < 0) months.push(m); });
      var monthsEl = root.querySelector('[data-cal-months]');
      var grid = root.querySelector('[data-cal-grid]');
      var head = root.querySelector('[data-cal-day-h]');
      var today = iso(new Date());
      var current = months[0], selected = dates[0];

      monthsEl.innerHTML = months.map(function (m) {
        var d = parse(m + '-01'), n = dates.filter(function (x) { return x.indexOf(m) === 0; }).reduce(function (a, x) { return a + byDate[x].length; }, 0);
        return '<button type="button" class="rxcal__month" role="tab" data-m="' + m + '" aria-selected="false">' + MONTHS[d.getMonth()].slice(0, 3) + (d.getFullYear() !== new Date().getFullYear() ? ' ' + d.getFullYear() : '') + '<small>' + n + '</small></button>';
      }).join('');

      function drawMonth(m) {
        current = m;
        monthsEl.querySelectorAll('[data-m]').forEach(function (b) { b.setAttribute('aria-selected', b.dataset.m === m ? 'true' : 'false'); });
        var first = parse(m + '-01'), y = first.getFullYear(), mo = first.getMonth();
        var lead = (first.getDay() + 6) % 7, days = new Date(y, mo + 1, 0).getDate(), html = '';
        for (var i = 0; i < lead; i++) html += '<span class="rxcal__cell is-pad" aria-hidden="true"></span>';
        for (var d = 1; d <= days; d++) {
          var key = m + '-' + pad(d), list = byDate[key], cls = 'rxcal__cell';
          if (key < today) cls += ' is-past';
          if (key === today) cls += ' is-today';
          if (list) {
            cls += ' has' + (key === selected ? ' is-on' : '');
            var th = list.slice(0, 2).map(function (r) { return r.dataset.thumb ? '<img src="' + r.dataset.thumb + '" alt="" loading="lazy">' : ''; }).join('');
            html += '<button type="button" class="' + cls + '" data-d="' + key + '" aria-pressed="' + (key === selected) + '" aria-label="' + d + ' ' + MONTHS[mo] + ': ' + list.length + (list.length === 1 ? ' release' : ' releases') + '"><b>' + d + '</b><span class="rxcal__thumbs">' + th + (list.length > 2 ? '<span class="rxcal__more">+' + (list.length - 2) + '</span>' : '') + '</span></button>';
          } else {
            html += '<span class="' + cls + '"><b>' + d + '</b></span>';
          }
        }
        grid.innerHTML = html;
      }
      function pick(d) {
        selected = d;
        rows.forEach(function (r) { r.hidden = r.dataset.date !== d; });
        var dt = parse(d), n = byDate[d].length;
        head.innerHTML = DAYS[dt.getDay()] + ' ' + dt.getDate() + ' ' + MONTHS[dt.getMonth()] + '<small>' + n + (n === 1 ? ' release' : ' releases') + (d === today ? ' today' : '') + '</small>';
        grid.querySelectorAll('[data-d]').forEach(function (c) { var on = c.dataset.d === d; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      }
      monthsEl.addEventListener('click', function (e) {
        var b = e.target.closest('[data-m]'); if (!b) return;
        drawMonth(b.dataset.m);
        var firstDay = dates.filter(function (x) { return x.indexOf(b.dataset.m) === 0; })[0];
        if (firstDay) pick(firstDay);
      });
      grid.addEventListener('click', function (e) {
        var c = e.target.closest('[data-d]'); if (!c) return;
        pick(c.dataset.d);
        if (window.matchMedia('(max-width: 989px)').matches) {
          var panel = root.querySelector('[data-cal-panel]');
          var top = panel.getBoundingClientRect().top + window.scrollY - 90;
          window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
        }
      });
      drawMonth(current); pick(selected);
    });
  }
  onAll(initCal);

  /* ---------------- Rewards slider ---------------- */
  function initCalc() {
    document.querySelectorAll('[data-calc]').forEach(function (root) {
      if (root.dataset.calcBound) return; root.dataset.calcBound = '1';
      var lv = root.dataset.lv.split(',').map(Number), fs = Number(root.dataset.fs) || 50;
      var range = root.querySelector('[data-calc-range]'), out = root.querySelector('[data-calc-out]'), msg = root.querySelector('[data-calc-msg]');
      var gifts = [].slice.call(root.querySelectorAll('[data-calc-gift]'));
      var quick = [].slice.call(root.querySelectorAll('[data-calc-set]'));
      var names = ['card sleeves', 'sleeves + toploaders', 'the Vault X binder', 'the mystery gift'];
      function update() {
        var v = Number(range.value), max = Number(range.max);
        out.textContent = '£' + v;
        range.style.setProperty('--p', (v / max * 100).toFixed(1) + '%');
        var level = 0; lv.forEach(function (t, i) { if (v >= t) level = i + 1; });
        gifts.forEach(function (g) {
          var l = Number(g.dataset.lvl), on = v >= Number(g.dataset.calcGift), st = g.querySelector('[data-calc-state]');
          var swapped = l === 1 && level >= 2;
          g.classList.toggle('is-on', on && !swapped);
          g.classList.toggle('is-swapped', swapped);
          st.textContent = swapped ? 'Upgraded at £' + lv[1] : (on ? 'In your bag' : 'From £' + g.dataset.calcGift);
        });
        quick.forEach(function (q) { q.classList.toggle('is-on', Number(q.dataset.calcSet) === v); });
        var got = [];
        if (level >= 2) got.push('sleeves + toploaders'); else if (level === 1) got.push('card sleeves');
        if (level >= 3) got.push('a Vault X binder');
        if (level >= 4) got.push('a mystery gift');
        var t = '';
        if (!got.length) t = 'Add <b>£' + (lv[0] - v) + '</b> to get free card sleeves.';
        else {
          t = 'A £' + v + ' basket gets <b>' + got.join(', ').replace(/, ([^,]*)$/, ' and $1') + '</b>' + (v >= fs ? ', plus free UK delivery.' : '.');
          if (level < 4) t += ' £' + (lv[level] - v) + ' more for ' + names[level] + '.';
        }
        msg.innerHTML = t;
      }
      range.addEventListener('input', update);
      quick.forEach(function (q) { q.addEventListener('click', function () { range.value = q.dataset.calcSet; update(); }); });
      update();
    });
  }
  onAll(initCalc);

  /* ---------------- Product page info tabs ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-pt]'); if (!t) return;
    var root = t.closest('[data-ptabs]'); if (!root) return;
    root.querySelectorAll('[data-pt]').forEach(function (b) {
      var on = b === t; b.setAttribute('aria-selected', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1;
      var p = document.getElementById(b.getAttribute('aria-controls')); if (p) p.hidden = !on;
    });
  });
  document.addEventListener('keydown', function (e) {
    var t = e.target.closest && e.target.closest('[data-pt]'); if (!t || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var all = [].slice.call(t.closest('[data-ptabs]').querySelectorAll('[data-pt]'));
    var n = all[(all.indexOf(t) + (e.key === 'ArrowRight' ? 1 : all.length - 1)) % all.length];
    e.preventDefault(); n.focus(); n.click();
  });
})();
